import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface ErrorOverlayData {
  message: string;
  title?: string;
  type: 'company' | 'access' | 'system';
}

@Injectable({
  providedIn: 'root',
})
export class ErrorOverlayService {
  private overlaySubject = new BehaviorSubject<{
    isVisible: boolean;
    data?: ErrorOverlayData;
  }>({
    isVisible: false,
    data: undefined
  });

  public overlay$ = this.overlaySubject.asObservable();

  constructor() {
   
  }


  showOverlay(data: ErrorOverlayData) {
    
    const defaultTitles = {
      company: 'You currently do not have permission to access any features in this application.',
      access: 'Access Denied',
      system: 'System Error'
    };

    const overlayData: ErrorOverlayData = {
      ...data,
      title: data.title || defaultTitles[data.type]
    };


    this.overlaySubject.next({
      isVisible: true,
      data: overlayData
    });

    const currentState = this.overlaySubject.value;
  }


  showCompanyOverlay(message: string, title?: string) {
    
    this.showOverlay({
      message,
      title: title || 'Access Restricted',
      type: 'company'
    });
  }

 
  showAccessDeniedOverlay(message: string, title?: string) {
    this.showOverlay({
      message,
      title: title || 'Access Denied',
      type: 'access'
    });
  }

  
  showSystemErrorOverlay(message: string, title?: string) {
    this.showOverlay({
      message,
      title: title || 'System Error',
      type: 'system'
    });
  }

  
  hideOverlay() {
    
    this.overlaySubject.next({
      isVisible: false,
      data: undefined
    });
  }

  isOverlayVisible(): boolean {
    const isVisible = this.overlaySubject.value.isVisible;
    return isVisible;
  }

  
  getCurrentOverlayData(): ErrorOverlayData | undefined {
    const data = this.overlaySubject.value.data;
    return data;
  }

  testOverlay() {
    this.showCompanyOverlay('This is a test message for debugging');
  }
}